(function($) {
	if ($('.header').hasClass('header--fixed')) {
		const updateHeaderHeight = () => {
			$('body').css('--header-height', $('.header').outerHeight());
		};

		updateHeaderHeight();

		$(window).on('scroll resize', updateHeaderHeight);
	} else {
		const headerHeight = $('.header').outerHeight();

		$('body').css('padding-top', headerHeight);
	}

	function headerScroll() {
		const header = document.querySelector('.header');
		let lastScrollTop = 0;
		const navbarHeight = header.offsetHeight;
		const delta = 32;
		const scrolledDelay = 400; // adjust delay as desired (ms)
		let scrolledTimeout = null;

		window.addEventListener('scroll', function() {
			const st = window.scrollY;

			const clearScrolledTimeout = () => {
				if (scrolledTimeout) {
					clearTimeout(scrolledTimeout);
					scrolledTimeout = null;
				}
			};

			if ($('body').hasClass('is-active-menu')) {
				clearScrolledTimeout();
				header.classList.add('scrolled-up');
				header.classList.remove('scrolled-down', 'header--scrolled');
				return;
			}

			if (Math.abs(lastScrollTop - st) <= delta) {
				return; // Ignore small scroll events
			}

			if (st > lastScrollTop && st > (navbarHeight / 5)) {
				// Scroll Down
				header.classList.remove('scrolled-up');
				header.classList.add('scrolled-down');

				clearScrolledTimeout();

				scrolledTimeout = setTimeout(function() {
					header.classList.add('header--scrolled');
				}, scrolledDelay);
			} else if (st + window.innerHeight < document.documentElement.scrollHeight) {
				// Scroll Up
				header.classList.add('scrolled-up');
				header.classList.remove('scrolled-down');

				clearScrolledTimeout();

				if (st < (navbarHeight / 5)) {
					header.classList.remove('header--scrolled');
				} else {
					header.classList.add('header--scrolled');
				}
			}

			lastScrollTop = st;
		});
	}

	// Function to toggle menu and control header and overlay behavior
	function toggleMenu() {
		$('.menu-toggle').on('click', function() {
			$('body').toggleClass('is-active-menu');
			$('.overlay').toggle();

			if ($('body').hasClass('is-active-menu')) {
				$('.header').css('top', '0');
				$(window).scroll();
			} else {
				$(window).trigger('scroll');
			}
		});
	}

	$(document).ready(function() {
		headerScroll();
		toggleMenu();
	});
}(window.jQuery));
